import ResponsiveCarousel from 'components/common/ResponsiveCarousel';
import { FunctionComponent } from 'react';
import { Organization } from 'types/organization.type';
import OrganizationCard from './OrganizationCard';
import OrganizationPageSectionTitle from './OrganizationPageSectionTitle';

interface OrganizationPageCategortSectionProps {
  organizations: Organization[];
  title: string;
  keyName: string;
  wrapperClass?: string;
  isCarousel?: boolean;
  prioritizeImg?: boolean;
}

const OrganizationPageCategortSection: FunctionComponent<
  OrganizationPageCategortSectionProps
> = ({
  title,
  organizations,
  keyName,
  wrapperClass,
  prioritizeImg = false,
  isCarousel = false,
}) => {
  return (
    <section className={wrapperClass}>
      <OrganizationPageSectionTitle title={title} className="mb-6" />
      {isCarousel ? (
        <ResponsiveCarousel spacing="px-1 md:px-3">
          {organizations.map((org) => (
            <OrganizationCard
              prioritizeImg={prioritizeImg}
              {...org}
              key={`${keyName}-${org.id}`}
            />
          ))}
        </ResponsiveCarousel>
      ) : (
        <div className="grid grid-cols-2 justify-items-center gap-4 md:gap-6 lg:grid-cols-3 xl:grid-cols-4">
          {organizations.map((org) => (
            <OrganizationCard
              prioritizeImg={prioritizeImg}
              {...org}
              key={`${keyName}-${org.id}`}
            />
          ))}
        </div>
      )}
    </section>
  );
};

export default OrganizationPageCategortSection;
